import { BUDGET_REFRESH_INTERVAL } from '../MealBudgets/modals/budget_helper';
import { ExpenseCodeEnforcementMode, PermittedOrderContents, } from '../MealBudgets/types/budgets';
import { formatDateToObject } from '../../utils/format_time';
import * as moment from 'moment-timezone';
// no i18n translation (for Kaiser only at this time)
export var getAutoCreatedGroupName = function (emailString) {
    return "Group of 1: " + emailString;
};
export var getAutoCreatedGroupDescription = function (emailString) {
    return "This group is auto created to use the one click place order feature. Please do not edit. Group is only for 1 member - " + emailString + ".";
};
export var BUDGET_EXPIRE_IN_DAYS = 5;
export var getOneTimeBudgetOptions = function (_a) {
    var name = _a.name, teamAccountId = _a.teamAccountId, unitAmount = _a.unitAmount, groupId = _a.groupId;
    var timeNowInMillis = new Date(Date.now()).getTime();
    var timeNowInSeconds = Math.floor(timeNowInMillis / 1000);
    var expireDaysInSeconds = BUDGET_EXPIRE_IN_DAYS * 24 * 60 * 60; // 24hr in a day, 60min in 1hr, 60sec in 1min
    var todayAsDateObject = formatDateToObject(moment());
    var expirationAsDateObject = formatDateToObject(moment().add(BUDGET_EXPIRE_IN_DAYS, 'days'));
    return {
        name: name,
        teamAccountId: teamAccountId,
        addressId: 0,
        daysList: [1, 2, 3, 4, 5, 6, 7],
        startTime: {
            // all time
            hours: 0,
            minutes: 0,
        },
        endTime: {
            // all time
            hours: 23,
            minutes: 59,
        },
        unitAmount: unitAmount,
        refreshInterval: BUDGET_REFRESH_INTERVAL.OneTime,
        activeAtTimestamp: {
            seconds: timeNowInSeconds,
        },
        inactiveAtTimestamp: {
            seconds: timeNowInSeconds + expireDaysInSeconds,
        },
        activeAtDate: todayAsDateObject,
        inactiveAtDate: expirationAsDateObject,
        groupIds: [groupId],
        expenseCodeConfig: {
            expenseCodeEnforcementMode: ExpenseCodeEnforcementMode.OPTIONAL_CODE,
            expenseCodeValidValuesList: [],
        },
        budgetConfig: {
            permittedOrderContentsList: [
                PermittedOrderContents.WORK_ORDER_CONTENT_RESTAURANT,
            ],
        },
    };
};
